import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./My_account.css";
import {
  LayoutDashboard,
  ShoppingBag,
  Download,
  MapPin,
  User,
  LogOut
} from "lucide-react";
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from "@mui/material";
import TrackOrder from "./Track_order";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";


function MyAccount() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("Address");
  const [userInfo, setUserInfo] = useState({});
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState('');
  const location = useLocation(); // Gets "/my-account/address"
  const parts = location.pathname.split("/");
  const lastPart = parts[parts.length - 1].replace(/\b\w/g, (char) => char.toUpperCase());

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  function handleLogout() {
    localStorage.removeItem('token');
    localStorage.removeItem('userFormData');
    localStorage.removeItem('billing_address');
    localStorage.removeItem('shipping_address');
    navigate("/register-login");
  }

  async function fetchdata(){
    try {
      const response = await fetch("https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/user-info",{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "token": token
        })
      });
      const data = await response.json();
      //console.log(data);
    } catch (error) {
      console.error(error);
    }
  }
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/register-login");
    }else{
      setToken(JSON.parse(token));
    }
    // const user = localStorage.getItem("userFormData");
    // if (user) {
    //   setUserInfo(JSON.parse(user));
    // }

    fetchdata();

    const billing = localStorage.getItem("billing_address");
    if (billing) {
      setUserInfo(JSON.parse(billing));
    }
    // setTitle(lastPart);

  }, [])
  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>


      <div className="my-account-container">
        <h1 className="my-account-title">{title}</h1>
        <div className="my-account-content-container">
          <div className="my-account-buttons-container">
            <button style={(title === "My Account") ? { color: "black", fontWeight: "500" } : {}} onClick={() => { setTitle("My Account"); navigate("/my-account") }}>Dashboard <LayoutDashboard className="mr-2" size={20} /></button>
            <button style={(title === "Orders") ? { color: "black", fontWeight: "500" } : {}} onClick={() => { setTitle("Orders"); navigate("/my-account/orders") }}>Orders <ShoppingBag className="mr-2" size={20} /></button>
            {/* <button style={(title === "Downloads") ? { color: "black", fontWeight: "500" } : {}} onClick={() => { setTitle("Downloads"); navigate("/my-account/downloads") }}>Downloads <Download className="mr-2" size={20} /></button> */}
            <button style={(title === "Address") ? { color: "black", fontWeight: "500" } : {}} onClick={() => { setTitle("Address"); navigate("/my-account/address") }}>Addresses <MapPin className="mr-2" size={20} /></button>
            {/* <button style={(title === "Account Details") ? { color: "black", fontWeight: "500" } : {}} onClick={() => { setTitle("Account Details"); navigate("/my-account/account-details") }}>Account Details <User className="mr-2" size={20} /></button> */}
            <button style={(title === "Logout") ? { color: "black", fontWeight: "500" } : {}} onClick={handleOpen} >Logout <LogOut className="mr-2" size={20} /></button>
          </div>
          <div className="my-account-content">
            {title === "My Account" && <div>
              <p>Hello <strong>{userInfo?.first_name} {userInfo?.last_name}</strong> (not <strong>{userInfo?.first_name} {userInfo?.last_name}?</strong> <span >Log out</span>)</p>
              <p>From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.</p>
            </div>}
            <Outlet />
          </div>
        </div>

        <div className="track-order-container">
          <TrackOrder />
        </div>

        <Dialog open={open} onClose={handleClose}>
          <DialogContent>
            <DialogContentText>
              You sure you want to logout?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleLogout} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <About_p />
      <Footer />
      <StickyComponent />
      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
    </>

  );
}

export default MyAccount;